import React, { PureComponent } from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import HamburgerMenu from 'react-hamburger-menu';
import MediaQuery from 'react-responsive';
import logo from '../resources/svg/logo-cheesybit.svg';
import cheesybit from '../resources/svg/cheesybit.svg';
import SearchBar from './SearchBar';
import HeaderManager from '../managers/HeaderManager';

class Header extends PureComponent {
  constructor() {
    super();
    this.state = { projects: [], open: false };
    const headMan = new HeaderManager();
    this.menu = headMan.getMenu();
    this.searchProjects = this.searchProjects.bind(this);
    this.emptySearch = this.emptySearch.bind(this);
    this.handleHamburgerClick = this.handleHamburgerClick.bind(this);
  }

  componentDidMount() {
    // Need to do this when links clicked from other pages
    const { history } = this.props;
    this.unlisten = history.listen((location) => {
      if (location.pathname !== '/menu') {
        this.setState({
          open: false,
        });
      }
    });
  }

  componentWillUnmount() {
    this.unlisten();
  }

  handleHamburgerClick() {
    const { open } = this.state;
    const { history } = this.props;
    this.setState({
      open: !open,
    });

    if (!open) {
      history.push({
        pathname: '/menu',
      });
    } else {
      history.goBack();
    }
  }

  searchProjects(searchProjects = []) {
    const { projects } = this.state;
    const { history } = this.props;
    console.log(projects);
    if (searchProjects.length && projects.length !== searchProjects.length) {
      history.push({ pathname: '/search', state: { projects: searchProjects } });
    }
    this.setState({
      projects: searchProjects,
    });
  }

  emptySearch() {
    this.setState({
      projects: [],
    });
    const { history } = this.props;
    history.push({ pathname: '/' });
  }

  render() {
    const { title } = this.props;
    const { open } = this.state;

    return (
      <div>
        <header className="header">
          <NavLink to="/" className="header__logo">
            <img src={logo} className="header__logo__image" alt="CheesyBit logo" />
          </NavLink>

          <div className="font-title-bold navigation">
            <NavLink to="/" className="navigation__logo_text">
              <img src={cheesybit} className="header__logo__text" alt={title} />
            </NavLink>

            <MediaQuery query="(min-device-width: 641px)">
              <NavLink
                className="navigation__link"
                activeClassName="navigation__link--active"
                to="/games"
              >
                {this.menu.games}
              </NavLink>

              <NavLink
                className="navigation__link"
                activeClassName="navigation__link--active"
                to="/more"
              >
                {this.menu.more}
              </NavLink>

              <NavLink
                className="navigation__link"
                activeClassName="navigation__link--active"
                to="/about"
              >
                {this.menu.about}
              </NavLink>

              <NavLink
                className="navigation__link"
                activeClassName="navigation__link--active"
                to="/contact"
              >
                {this.menu.contact}
              </NavLink>

              <SearchBar searchPage={this.searchProjects} emptySearch={this.emptySearch} />
            </MediaQuery>
            <MediaQuery query="(max-device-width: 640px)">
              <div className="navigation__pointer">
                <HamburgerMenu
                  className="navigation__link "
                  isOpen={open}
                  menuClicked={this.handleHamburgerClick}
                  width={18}
                  height={18}
                  strokeWidth={2.5}
                  rotate={0}
                  color="white"
                  borderRadius={2.5}
                  animationDuration={0.5}
                />
              </div>
            </MediaQuery>
          </div>
        </header>
      </div>
    );
  }
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js